import { oc } from '@orpc/contract';
import { listRoutesInputSchema, listRoutesOutputSchema } from '../schemas/routes.schemas.js';
export const listRoutesContract = oc
    .route({
    method: 'GET',
    path: '/routes',
    tags: ['Routes'],
    summary: 'List test routes and their revisions',
})
    .input(listRoutesInputSchema)
    .output(listRoutesOutputSchema);
//# sourceMappingURL=list-routes.contract.js.map